export default __webpack_public_path__ + "static/media/clientInfo.d96750c0.svg";